import styled from 'styled-components'
import { push } from 'connected-react-router'
import { db } from '../firebase'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Layout, BrandCard, NewsCard, MagazineCard, WhatsNewCard, PickUpSwiper, PrimaryButton } from '../components'
import heroPC from '../assets/bnr-rzeus-pc.jpg'
import heroSP from '../assets/bnr-rzeus-sp.jpg'

const Top = () => {
    const dispatch = useDispatch()

    // ニュース情報取得
    const [tempNewsList] = useState([])
    const [newsList, setNewsList] = useState([])
    useEffect( () => {
        db.collection('news')
            .where("isDraft","==",false)
            .where("isTrash","==",false)
            .orderBy("created_at", "desc")
            .limit(3)
            .get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    const data = snapshot.data()
                    tempNewsList.push({
                        id: data.id,
                        title: data.title,
                        image: data.image,
                        isDraft: data.isDraft,
                        isTrash: data.isTrash,
                        date: data.created_at
                    })
                })
                setNewsList(tempNewsList)
            })
        return null
    }, [tempNewsList])

    // マガジン情報取得 for Whats New
    const [tempWhatsNewList] = useState([])
    const [whatsNewList, setWhatsNewList] = useState([])
    useEffect( () => {
        db.collection('magazines')
            .where("isDraft", "==", false)
            .where("isTrash", "==", false)
            .orderBy("updated_at", "desc")
            .limit(4)
            .get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    const data = snapshot.data()
                    tempWhatsNewList.push({
                        id: data.id,
                        external: data.external,
                        externalLink: data.externalLink,
                        title: data.title,
                        image: data.image,
                        category: data.category,
                        isDraft: data.isDraft,
                        isTrash: data.isTrash,
                        date: data.created_at
                    })
                })
                setWhatsNewList(tempWhatsNewList)
            })
        return null
    }, [tempWhatsNewList])

    // マガジン情報取得 for PickUp
    const [tempPickupList] = useState([])
    const [pickupList, setPickupList] = useState([])
    useEffect( () => {
        db.collection('magazines')
            .where("isDraft", "==", false)
            .where("isTrash", "==", false)
            .orderBy("id", "desc").limit(9)
            .get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    const data = snapshot.data()
                    tempPickupList.push({
                        id: data.id,
                        external: data.external,
                        externalLink: data.externalLink,
                        image: data.image,
                        isDraft: data.isDraft,
                        isTrash: data.isTrash,
                    })
                })
                setPickupList(tempPickupList)
            })
        return null
    }, [tempPickupList])

    // マガジン情報取得
    const [tempMagazineList] = useState([])
    const [magazineList, setMagazineList] = useState([])
    useEffect( () => {
        db.collection('magazines')
            .where("isDraft", "==", false)
            .where("isTrash", "==", false)
            .orderBy("created_at", "desc")
            .limit(3)
            .get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    const data = snapshot.data()
                    tempMagazineList.push({
                        id: data.id,
                        external: data.external,
                        externalLink: data.externalLink,
                        title: data.title,
                        image: data.image,
                        category: data.category,
                        isDraft: data.isDraft,
                        isTrash: data.isTrash,
                        date: data.created_at
                    })
                })
                setMagazineList(tempMagazineList)
            })
        return null
    }, [tempMagazineList])

    return (
        <Layout>
            <HeroPC style={{cursor:'pointer'}} onClick={()=>dispatch(push('/brand/rzeus'))}>
                <img src={heroPC} alt={'hero'} />
            </HeroPC>
            <HeroSP style={{cursor:'pointer'}} onClick={()=>dispatch(push('/brand/rzeus'))}>
                <img src={heroSP} alt={'hero'} />
            </HeroSP>
            {/* What's New */}
            <section>
                <div className='spacer-100' />
                <StyledHeading>What's New</StyledHeading>
                <div className='spacer-50' />
                <WhatsNewWrapper>
                    { whatsNewList.length > 0 && (
                        whatsNewList.map(magazine => (
                            <WhatsNewCard 
                                key={magazine.id} id={magazine.id} 
                                external={magazine.external}
                                externalLink={magazine.externalLink}
                                image={magazine.image}
                                title={magazine.title}
                                date={magazine.date}
                                category={magazine.category}
                                isDraft={magazine.isDraft}
                                isTrash={magazine.isTrash}
                            />
                        )) 
                    )}
                </WhatsNewWrapper>
                <div className='spacer-50' />
            </section>

            <section>
                <div className='spacer-100'></div>
                <StyledHeading>News</StyledHeading>
                <div className='spacer-50'></div>
                <PostListWrapper>
                    { newsList.length > 0 && (
                        newsList.map(news => (
                            <NewsCard 
                                key={news.id} id={news.id} 
                                title={news.title}
                                date={news.date}
                                isDraft={news.isDraft}
                                isTrash={news.isTrash}
                            />
                        )) 
                    )}
                </PostListWrapper>
                <div className='spacer-50'></div>
                <div style={{textAlign:'center'}}>
                    <PrimaryButton label="View List" operation={()=> dispatch(push('/news'))} />
                </div>
                <div className='spacer-100'></div>
            </section>

            {/* ピックアップ */}
            <section>
                <div className='spacer-100' />
                <StyledHeading>Pick Up</StyledHeading>
                <div className='spacer-50' />
                <PickUpWrapper>
                    <PickUpSwiper magazineList={pickupList} />
                </PickUpWrapper>
                <div className='spacer-100' />
            </section>

            {/* ブランド */}
            <section>
                <div className='spacer-100'></div>
                <StyledHeading>Brands</StyledHeading>
                <div className='spacer-50'></div>
                <BrandsWrapper>
                    <BrandCard brand={'rzeus'} />
                    {/* <BrandCard brand={'hermes'}/> */}
                    {/* <BrandCard brand={'poseidon'}/> */}
                </BrandsWrapper>
                <div className='spacer-100'></div>
            </section>

            <section>
                <div className='spacer-100'></div>
                <StyledHeading>Magazine</StyledHeading>
                <div className='spacer-50'></div>

                <PostListWrapper>
                    { magazineList.length > 0 && (
                        magazineList.map(magazine => (
                            <MagazineCard 
                                key={magazine.id} id={magazine.id} 
                                external={magazine.external}
                                externalLink={magazine.externalLink}
                                image={magazine.image}
                                title={magazine.title}
                                category={magazine.category}
                                date={magazine.date}
                                isDraft={magazine.isDraft}
                                isTrash={magazine.isTrash}
                            />
                        )) 
                    )}
                </PostListWrapper>
                <div className='spacer-50' />

                <div style={{textAlign:'center'}}>
                    <PrimaryButton label="View List" operation={()=> dispatch(push('/magazine'))} />
                </div>
                <div className='spacer-100'></div>
            </section>

           
            {/* 旧ヘッダー */}
            {/* <div className='slide-wrapper' style={{backgroundImage: `url(${dummy1})`}}> 
                <p className='slide-title'>DUMMY CAMPAIGN AAA</p>
            </div> */}

            {/* 旧ヒーロー */}
            {/* <HeroSwiper /> */}

            {/* 旧商品一覧 */}
            {/* <section>
            <div className='spacer-100'></div>
            <h3>PRODUCTS</h3>
            <div className='spacer-50'></div>
            <div className='product-list-wrapper'>
                { products.length > 0 && (
                    products.map((product) => (
                        <ProductCard 
                            key={product.id} 
                            id={product.id} 
                            images={product.images} 
                            name={product.name}
                            price={product.price}
                        />
                    )) 
                )}
            </div>
            <div className='primary-button'>
                <Button variant="outlined" onClick={()=> dispatch(push('/product'))}>一覧を見る</Button>
            </div>
            </section>
            <div className='spacer-50'></div> */}

            {/* 旧ビデオ */}
            {/* <section className='video-wrapper '>
                <video src={barcelonaMovie} playsInline autoPlay loop muted ></video>
            </section>
            <div className='spacer-50'></div> */}

            {/* 旧About */}
            {/* <section>
            <h3>About</h3>
            <div className='spacer-50'></div>
            
            <div className='primary-button'>
                <Button variant="outlined" onClick={()=> dispatch(push('/about'))}>詳細を見る</Button>
            </div>
            </section>
            <div className='spacer-50'></div> */}
        </Layout>
    )
}

export default Top

const HeroPC = styled.div`
    display: block;
    width: 100vw;
    margin-top:15px;
    img {
        width: 100%;
    }
    @media screen and (max-width:768px){
        display: none !important;
    }
`
const HeroSP = styled.div`
    display: none;
    width: 100vw;
    margin-top:15px;
    img {
        width: 100%;
    }
    @media screen and (max-width:768px){
        display: block !important;
    }
`
const Wrapper = styled.div`
    width: 1040px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
const WhatsNewWrapper = styled(Wrapper)`
    @media screen and (max-width:1040px){
        width: 520px;
        flex-wrap: wrap;
    }
    @media screen and (max-width:520px){
        width: 340px;
    }
`
const PickUpWrapper = styled(Wrapper)`
    height: 500px;
    background-color: transparent;
    padding: 20px;
    @media screen and (max-width:960px){
        width: 300px;
    }
`
const BrandsWrapper = styled(Wrapper)`
    @media screen and (max-width:768px){
        width: 100%;
        flex-direction: column;
        align-items: center;
    }
`
const PostListWrapper = styled(Wrapper)`
    width: 640px;
    flex-direction: column;
    @media screen and (max-width:768px){
        width: 100%;
    }
`

const StyledHeading = styled.h1`
    font-size: 4rem;
    color: #fff;
    text-align: center;
    position: relative;
    &:before {
        position: absolute;
        top: -3px;
        left: calc(55% - 400px);
        width: 400px;
        height: 10px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: -10px;
        right: 0;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
    @media screen and (max-width:768px){
        font-size: 3rem;
    }
`